import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
// import { useState } from "react";

// interface Props {
//   type: string;
//   propertyId: string;
// }

export const useCreateShareLink = (
  type: string,
  propertyId?: string,
  userType?: string
) => {
  const axios = useAxios();
  const { t } = useTranslation();
  // const [isQueryEnabled, setIsQueryEnabled] = useState(false);
  // const [queryProps, setQueryProps] = useState<Props | null>(null);
  const urlKey = `${t("generate-share-link-api")}/${type}/${propertyId}`;

  const { data, isLoading } = useQuery({
    queryKey: ["Generate-Share-Link", type, propertyId],
    queryFn: async () => {
      if (userType !== "investor") {
        // if (shareLinks?.length === 1 || shareLinks?.length === 0) {
        const res = await axios.get(urlKey);
        // await queryClient.setQueryData(
        //   ["Property-Detail", propertyId],
        //   (oldData: any) => {
        //     const updatedData = {
        //       ...oldData,
        //       shareLinks: [
        //         ...oldData?.shareLinks.filter(
        //           (link: { type: string | undefined }) => link.type !== type
        //         ),
        //         { ...res.data.data, type: type }
        //       ]
        //     };
        //     return { ...oldData, data: updatedData };
        //   }
        // );
        // setIsQueryEnabled(false); // Disable query after it completes
        return { ...res.data?.data, type: type };
      } else {
        return {};
      }
      // }
    },
    enabled: !!propertyId
    // enabled: isQueryEnabled
  });

  // const fetchData = (type: string, propertyId: string) => {
  //   setQueryProps({ type, propertyId });
  //   setIsQueryEnabled(true); // Enable the query to trigger fetching
  // };

  return { data, isLoading };
};
